import { Injectable } from '@angular/core';
import { LocalParkingFeeCalculationFull } from '../../models/parking/local-parking-fee-calc.model';

@Injectable({ providedIn: 'root' })
export class MapperLocalParkingFeeCalcService {
  mapCalculation(res: unknown): LocalParkingFeeCalculationFull {
    const r = (res ?? {}) as Record<string, unknown>;
    return {
      success: !!(r['success'] ?? r['Success']),
      message: String(r['message'] ?? r['Message'] ?? ''),
      transactionId: Number(r['transactionId'] ?? r['TransactionId'] ?? 0),
      siteId: Number(r['siteId'] ?? r['SiteId'] ?? 0),
      companyId: Number(r['companyId'] ?? r['CompanyId'] ?? 0),
      cardCode: String(r['cardCode'] ?? r['CardCode'] ?? ''),
      cardTypeId: this.toNullableNumber(r['cardTypeId'] ?? r['CardTypeId']),
      vehicleTypeId: this.toNullableNumber(r['vehicleTypeId'] ?? r['VehicleTypeId']),
      vehicleTypeLabel: String(r['vehicleTypeLabel'] ?? r['VehicleTypeLabel'] ?? ''),
      entryGateId: this.toNullableNumber(r['entryGateId'] ?? r['EntryGateId']),
      isReprint: !!(r['isReprint'] ?? r['IsReprint']),
      isMemberCard: !!(r['isMemberCard'] ?? r['IsMemberCard']),
      entryDate: this.parseDate(r['entryDate'] ?? r['EntryDate']),
      exitDate: this.parseDate(r['exitDate'] ?? r['ExitDate']),
      stampRateId: String(r['stampRateId'] ?? r['StampRateId'] ?? ''),
      defaultRateId: String(r['defaultRateId'] ?? r['DefaultRateId'] ?? ''),
      couponFreeMinutes: Number(r['couponFreeMinutes'] ?? r['CouponFreeMinutes'] ?? 0),
      totalMin: Number(r['totalMin'] ?? r['TotalMin'] ?? 0),
      customerMin: Number(r['customerMin'] ?? r['CustomerMin'] ?? 0),
      companyMin: Number(r['companyMin'] ?? r['CompanyMin'] ?? 0),
      ownerFreeMin: Number(r['ownerFreeMin'] ?? r['OwnerFreeMin'] ?? 0),
      companyFreeMin: Number(r['companyFreeMin'] ?? r['CompanyFreeMin'] ?? 0),
      parkingFee: Number(r['parkingFee'] ?? r['ParkingFee'] ?? 0),
      companyFee: Number(r['companyFee'] ?? r['CompanyFee'] ?? 0),
      parkingOvernight: Number(r['parkingOvernight'] ?? r['ParkingOvernight'] ?? 0),
      penaltyFee: Number(r['penaltyFee'] ?? r['PenaltyFee'] ?? 0),
      discount: Number(r['discount'] ?? r['Discount'] ?? 0),
      paidParking: Number(r['paidParking'] ?? r['PaidParking'] ?? 0),
      paidPenalty: Number(r['paidPenalty'] ?? r['PaidPenalty'] ?? 0),
      totalPay: Number(r['totalPay'] ?? r['TotalPay'] ?? 0),
      remarkTh: String(r['remarkTh'] ?? r['RemarkTh'] ?? ''),
      remarkEng: String(r['remarkEng'] ?? r['RemarkEng'] ?? ''),
    };
  }

  private toNullableNumber(value: unknown): number | null {
    if (value === null || value === undefined || value === '') return null;
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
  }

  private parseDate(value: unknown): Date | null {
    if (value == null || value === '') return null;
    const d = new Date(String(value));
    return Number.isNaN(d.getTime()) ? null : d;
  }
}
